import React from "react"
import * as styles from "./AbbrBox.module.scss"

type AbbrBoxProps = {
  /** Abbreviation or acronym */
  label: string
  /** If present, title must contain this full description and nothing else */
  title?: string
}

/**
 * HTML `<abbr>` element. Represents an abbreviation or acronym. the optional title attribute can provide an expansion or description for the abbreviation.
 *
 * See {@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/abbr|MDN docs: The Abbreviation element}
 */
const AbbrBox = (props: AbbrBoxProps) => {
  // console.debug('Rendering AbbrBox', props)
  if (!props.label) {
    console.warn(`Unlabeled AbbrBox: ${props.title}`)
  }

  return (
    <abbr title={props.title} className={styles.abbr}>
      {props.label || props.title}
    </abbr>
  )
}

export default AbbrBox
